import { render } from "./Search_Ticket.vue?vue&type=template&id=fdcf6dec&scoped=true"
import script from "./Search_Ticket.vue?vue&type=script&lang=js"
export * from "./Search_Ticket.vue?vue&type=script&lang=js"

import "./Search_Ticket.vue?vue&type=style&index=0&id=fdcf6dec&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdcf6dec"]])

export default __exports__